import { makeStyles } from '@material-ui/core/styles'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal'
import useListAction from 'core/hooks/useListAction'
import React, { useEffect, useState } from 'react'
import { listApplicationDetails } from '../repositories/actions'
import Progress from 'core/components/progress/Progress'
import { appDetailsSelector } from '../repositories/selector'
import { useAppSelector } from 'app/store'
import CopyToClipboard from 'core/components/CopyToClipboard'
import { stripAnsiCodes } from './helper'

const FailedStatusDetailsDialog = ({ rows: [appDetails], onClose }) => {
  const classes = useStyles()
  const { loading, reload } = useListAction(listApplicationDetails, {
    params: {
      uid: appDetails?.uid,
    },
    loadOnDemand: true,
  })
  const appErrorDetails = useAppSelector(appDetailsSelector)
  const rawError = appErrorDetails?.[0]?.error || ''
  const cleanedError = stripAnsiCodes(rawError)

  useEffect(() => {
    reload(true)
  }, [appDetails])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={appDetails?.headerName}
      maxWidth={1000}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <CopyToClipboard copyText={rawError} inline codeBlock={false} triggerWithChild>
            <Button type="button" icon="copy">
              Copy
            </Button>
          </CopyToClipboard>
        </>
      }
    >
      <Progress loading={loading} message={'Loading...'} renderContentOnMount={!!open}>
        <div className={classes.contentContainer}>
          <Text variant="caption1">
            The Application is getting failed due to the following error :{' '}
          </Text>
          <Text className={classes.errorContainer} variant="body2" component="pre">
            {cleanedError}
          </Text>
        </div>
      </Progress>
    </Modal>
  )
}

export default FailedStatusDetailsDialog

const useStyles = makeStyles<Theme>((theme) => ({
  contentContainer: {
    display: 'grid',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  errorContainer: {
    color: theme.palette.red[500],
  },
}))
